const StBartsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112446)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M35.71 16.087H29.1303C29.1303 14.8864 28.157 13.9131 26.9564 13.9131L25.2173 17.3913C25.2173 17.3913 27.0724 22.6087 27.0144 22.6087H29.1883C30.3889 22.6087 31.3622 21.6355 31.3622 20.4348C32.5628 20.4348 33.5361 19.4616 33.5361 18.261H33.4637C34.6643 18.2609 35.71 17.2877 35.71 16.087Z"
        fill="#ACABB1"
      />
      <path
        d="M4.28955 16.087H10.8692C10.8692 14.8864 11.8425 13.9131 13.0431 13.9131L14.7823 17.3913C14.7823 17.3913 12.9272 22.6087 12.9852 22.6087H10.8113C9.61063 22.6087 8.63741 21.6355 8.63741 20.4348C7.43674 20.4348 6.46352 19.4616 6.46352 18.261H6.53592C5.33525 18.2609 4.28955 17.2877 4.28955 16.087Z"
        fill="#ACABB1"
      />
      <path
        d="M26.9562 27.8271V28.6967H13.0432V27.8271H9.56494V31.3054H13.0432V32.1749H26.9562V31.3054H30.4345V27.8271H26.9562Z"
        fill="#FFDA44"
      />
      <path
        d="M13.0435 13.9125V22.6081C13.0435 27.933 19.9999 29.5646 19.9999 29.5646C19.9999 29.5646 26.9564 27.933 26.9564 22.6081V13.9125L19.9999 13.043L13.0435 13.9125Z"
        fill="#0052B4"
      />
      <path d="M13.0435 17.3916H26.9564V22.609H13.0435V17.3916Z" fill="#D80027" />
      <path
        d="M23.4782 9.56631V10.8707L22.6086 11.3055L21.7391 10.4359V7.82715H18.2609V10.4359L17.3913 11.3055L16.5217 10.8707V9.56631H13.0435V13.9141H26.9565V9.56631H23.4782Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112446">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default StBartsSvg;
